<template>
  <ModalWrapper :model-name="modelName">
    <div class="generations-over">
      <div class="generations-over-head">
        <p class="generations-over-head_title">
          <span class="green-text">Free generations are over!</span>
        </p>
        <div @click="onClose" class="generations-over-head_close">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18.835 18.8847C19.2832 18.4276 19.2832 17.6805 18.8438 17.2411L13.6494 12.0468L18.8438 6.84364C19.2832 6.40418 19.292 5.64832 18.835 5.20008C18.3867 4.75184 17.6309 4.75184 17.1914 5.19129L11.9971 10.3856L6.79395 5.19129C6.37207 4.76063 5.59863 4.74305 5.15039 5.20008C4.70215 5.64832 4.71094 6.42176 5.1416 6.84364L10.3359 12.0468L5.1416 17.2411C4.71094 17.6718 4.70215 18.4364 5.15039 18.8847C5.60742 19.3329 6.37207 19.3241 6.79395 18.9022L11.9971 13.6991L17.1914 18.8934C17.6309 19.3329 18.3867 19.3329 18.835 18.8847Z" />
          </svg>
        </div>
      </div>
      <div class="generations-over_body">
        <p class="generations-over_title">
         Top up your credits!
        </p>
        <p class="generations-over-promo">Undress the girls completely or choose from 15 sex poses for just <span class="green-text">$2 for 3 generations.</span></p>
        <p class="generations-over-promo"><span class="red-text">💥 Limited time only</span>  — use promo code <span class="green-text" @click="copyPromoCode">{{ promoCode }}</span>  <span class="red-text">within 5 minutes
         (regular price — $10)</span></p>
        <button
            @click="redirectToOrder"
            class="generations-over_button green-btn green-btn-with-pulse mb-20 mt-20"
        >
          Top Up with Discount
        </button>
        <p class="capitalize mt-10 mb-5">🔓 What you unlock after activation:</p>
        <ul class="generations-over_list mb-20">
          <li class="generations-over_list-item">
            <p class="generations-over_list-item-text">
              ✅ Full nudity
            </p>
          </li>
          <li class="generations-over_list-item">
            <p class="generations-over_list-item-text">
              ✅ 15 seductive poses
            </p>
          </li>
          <li class="generations-over_list-item">
            <p class="generations-over_list-item-text">
              ✅ Characters and roles that ignite your fantasies
            </p>
          </li>
          <li class="generations-over_list-item">
            <p class="generations-over_list-item-text">
              ✅ Instant, unlimited access
            </p>
          </li>
        </ul>
        <p class="generations-over_example">
          <span class="generations-over_example-item">
            <img src="@/assets/cumshot/teacher.webp" alt="teacher" />
          </span>

          <span class="generations-over_example-item">
            <img src="@/assets/breast/nun.webp" alt="nun" />
          </span>

          <span class="generations-over_example-item">
            <img src="@/assets/bbc/student.webp" alt="student" />
          </span>

          <span class="generations-over_example-item">
            <img src="@/assets/mission/teacher.webp" alt="teacher" />
          </span>

          <span class="generations-over_example-arrow">
            <img src="@/assets/icons/arrow-long.svg" alt="arrow" />
          </span>
        </p>
        <p class="generations-over_example-text">
          <span class="generations-over_example-text-plus">+</span> 15more
        </p>
      </div>
      <div class="generations-over_footer">
        <button
          @click="redirectToOrder"
          class="generations-over_button green-btn green-btn-with-pulse"
        >
          Top Up with Discount
        </button>
      </div>
    </div>
  </ModalWrapper>
</template>

<script>
import ModalWrapper from "@/components/modals/ModalWrapper.vue";
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import {ref} from "vue";
export default {
  name: "GenerationsOverModal",
  components: {
    ModalWrapper,
  },
  props: {
    modelName: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const router = useRouter();
    const store = useStore();
    const promoCode = ref('SMNKD80');

    const onClose = () => {
      store.commit("removeAllModal");
      emit("closeModal");
    };

    const copyPromoCode = async () => {
      try {
        await navigator.clipboard.writeText(promoCode.value);
        store.dispatch("handleToast", {
          text: "Promo code copied!",
          type: "SUCCESS",
        });
      } catch (err) {
        console.error('Copy failed:', err);
      }
    };

    const redirectToOrder = () => {
      store.commit("removeAllModal");
      emit("closeModal");
      router.push({
        name: "BuyCredits",
        query: { promo: promoCode.value }
      });
    };

    return {
      onClose,
      redirectToOrder,
      promoCode,
      copyPromoCode,
    };
  },
};
</script>

<style lang="scss" scoped>
.generations-over {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  margin: 0 auto;
  max-width: 718px;
  width: 95%;
  border-radius: 30px;
  background: #000;
  overflow: auto;
  max-height: 95vh;

  &-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    background: #3E3E3E;
    border-bottom: 2px solid #ACF601;
    padding: 16px 25px 16px 25px;
    position: relative;
    &_title {
      font-weight: 700;
      font-size: 26px;
      text-transform: capitalize;
      max-width: 417px;
      margin: 0 auto;
      text-align: center;

      @media screen and (max-width: 600px) {
        font-size: 22px;
      }

      @media screen and (max-width: 500px) {
        font-size: 20px;
      }

      @media screen and (max-width: 450px) {
        font-size: 18px;
      }

      @media screen and (max-width: 390px) {
        font-size: 16px;
      }

      span {
        color: #ACF601;
      }
    }
    &_close {
      cursor: pointer;
      position: absolute;
      right: 25px;
      top: 50%;
      transform: translateY(-50%);
      width: 49px;
      height: 38px;
      background: #ACF601;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        width: 24px;
        height: 24px;
        fill: #3E3E3E;
      }

      @media screen and (max-width: 500px) {
        width: 30px;
        height: 30px;
      }
    }
  }
  &_body {
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    padding: 25px 25px 0;
  }

  &_title {
    color: #FFF;
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    max-width: 346px;
    margin: 0 auto 20px;
    text-align: center;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    text-decoration-color: #ACF601;
    text-decoration-thickness: 10%;
    text-underline-offset: 13.5%;
    text-underline-position: from-font;

    span {
      color: #ACF601;
    }

    @media screen and (max-width: 500px) {
      font-size: 20px;
    }
  }

  &_list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    margin: 20px 50px 20px;

    @media screen and (max-width: 600px) {
      margin: 20px 0 20px;
    }

    &-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 25px;

      @media screen and (max-width: 450px) {
        max-width: 150px;
      }

      &-icon {
        img {
          width: 30px;
          height: 30px;
        }
      }

      &-text {
        font-size: 18px;
        line-height: 100%;
        color: #FFF;
        font-style: normal;
        font-weight: 500;

        @media screen and (max-width: 600px) {
          font-size: 16px;
        }

        @media screen and (max-width: 500px) {
          font-size: 14px;
        }

        @media screen and (max-width: 450px) {
          font-size: 12px;
        }

        span {
          color: #ACF601;
        }
      }
    }
  }

  &_example {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 25px;
    position: relative;

    @media screen and (max-width: 1024px) {
      gap: 15px;
    }

    &-arrow {
      width: 75px;
      height: 200px;
      position: absolute;
      top: 50%;
      left: 97%;

      @media screen and (max-width: 1024px) {
        top: 104%;
        left: 80%;
        width: 34px;
        height: 90px;
      }

      @media screen and (max-width: 500px) {
        display: none;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &-item {
      max-width: 111px;
      width: 16vw;
      min-width: 55px;
      max-height: 133px;
      height: 20vw;
      min-height: 70px;
      flex-shrink: 0;
      border-radius: 2vw;
      border: 2px solid #ACF601;
      overflow: hidden;

      @media screen and (min-width: 1440px) {
        border-radius: 30px;
      }

      @media screen and (max-width: 500px) {
        &:nth-child(3) {
          display: none;
        }
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &-text {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;

      span {
        color: #ACF601;
        text-align: center;
        font-size: 44px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }
    }
  }

  &_footer {
    padding: 0 25px 25px 25px;
    display: flex;
    justify-content: center;

    &-info {
      text-align: center;
      margin-bottom: 20px;
      padding: 0 25px;
    }
  }

  &_button {
    cursor: pointer;
    border: none;
    max-width: 258px;
    box-shadow: 1px 2px 10px #67eb00;
    outline: none;
    transition: all 0.3s;
    border-radius: 20px;
    background: #ACF601;
    height: 60px;
    color: #000;
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    text-transform: capitalize;
    &:hover {
      box-shadow: 1px 2px 25px #67eb00;
      color: rgba(0, 0, 0, 1);
    }
    &--disabled {
      opacity: 0.55;
      cursor: not-allowed;
    }

    @media screen and (max-width: 1024px) {
      font-size: 18px;
      height: 50px;
      border-radius: 10px;
    }

    @media screen and (max-width: 768px) {
      font-size: 16px;
      height: 40px;
      border-radius: 8px;
    }
  }

  .capitalize {
    text-transform: capitalize;
    text-align: center;
    font-weight: bold;

    @media screen and (max-width: 500px) {
      font-size: 14px;
    }
  }

  &-promo {
    text-transform: capitalize;
    text-align: center;
    font-weight: bold;
    margin-bottom: 10px;

    @media screen and (max-width: 500px) {
      font-size: 14px;
    }
  }
}
</style>
